package xim.poc.ui

import xim.math.Vector2f
import xim.poc.UiElementHelper
import xim.poc.UiResourceManager
import xim.poc.game.QueryMenuOption
import xim.poc.game.UiState
import xim.resource.*
import kotlin.math.max
import kotlin.math.min

object QueryUi {

    private const val baseMenuName = "menu    query   "
    private val fakeMenus = HashMap<Int, String>()

    fun getMenu(optionsCount: Int, visibleOptions: Int): String {
        val size = max(3, min(optionsCount, visibleOptions))
        if (size == 3) { return baseMenuName }
        return fakeMenus.getOrPut(size) { makeMenu(size) }
    }

    fun draw(uiState: UiState, prompt: String, options: List<QueryMenuOption>) {
        val position = uiState.latestPosition ?: return
        UiElementHelper.drawString(prompt, position + Vector2f(8f, 10f))

        val menu = uiState.latestMenu ?: return
        val scrollSettings = uiState.scrollSettings ?: return

        val max = min(options.size, scrollSettings.numElementsInPage)
        for (i in 0 until  max) {
            val itemIndex = i + scrollSettings.lowestViewableItemIndex
            val option = options[itemIndex].text

            val element = menu.elements[i]
            val elementOffset = element.offset + position
            UiElementHelper.drawString(option, elementOffset)
        }
    }

    private fun makeMenu(visibleOptions: Int): String {
        val baseMenu = UiResourceManager.getMenu("menu    query   ") ?: throw IllegalStateException("Could not find $baseMenuName")

        val newFrame = baseMenu.uiMenu.frame.deepCopy()
        newFrame.size.y = 28f + visibleOptions * 19f

        val baseElements = baseMenu.uiMenu.elements
        val referenceElement = baseElements[1]

        val newElements = ArrayList<UiMenuElement>()
        val baseOffset = Vector2f(x = referenceElement.offset.x, y = 29f)

        for (i in 0 until visibleOptions) {
            val navIndex = i+1
            val navigation = mapOf(
                UiMenuCursorKey.Up to (navIndex - 1).coerceAtLeast(1),
                UiMenuCursorKey.Left to navIndex,
                UiMenuCursorKey.Right to navIndex,
                UiMenuCursorKey.Down to (navIndex+1).coerceAtMost(visibleOptions),
            )

            newElements += UiMenuElement(
                offset = Vector2f().copyFrom(baseOffset),
                size = Vector2f().copyFrom(referenceElement.size),
                next = navigation,
                options = referenceElement.options.toMap(),
                selectable = referenceElement.selectable,
            )
            baseOffset.y += 19f
        }

        val newMenuName = "menu    query${visibleOptions}".padEnd(16, ' ')
        val newMenu = UiMenu(name = newMenuName, frame = newFrame, elements = newElements)
        UiResourceManager.register(UiMenuResource(DatId.zero, newMenu))

        return newMenuName
    }

}